import { useState } from 'react'
import { message as $message } from 'antd'
import { hasSignAgreement, signAgreement } from '@/services/config'

interface useCardReturn {
    showAgreementMap: any
    hasSignAgreementMap: any
    getIsSign: any
    fetchSignAgreement: any
    updateHasSignAgreement: any
    submitAgreement: any
}

/**
 * 签约信息
 * @returns @interface useCardReturn
 */
export default function useSignAgreement(): useCardReturn {
    const [hasSignAgreementMap, setHasSignAgreementMap] = useState({})
    const [showAgreementMap, setShowAgreementMap] = useState({})

    const getIsSign = async agreementType => {
        const res = await hasSignAgreement({
            agreement: agreementType
        })
        if (res.success) {
            setShowAgreementMap({
                ...showAgreementMap,
                [agreementType]: !res.data
            })
            setHasSignAgreementMap({ ...hasSignAgreementMap, [agreementType]: res.data })
        } else {
            $message.error(res.message)
        }
    }

    // 签名
    const fetchSignAgreement = async agreementType => {
        const { success } = await signAgreement({
            agreement: agreementType
        })
        if (success) {
            setHasSignAgreementMap({
                ...hasSignAgreementMap,
                [agreementType]: true
            })
        }
    }

    const updateHasSignAgreement = (agreementType, bool) => {
        setHasSignAgreementMap({
            ...hasSignAgreementMap,
            [agreementType]: bool
        })
    }

    const submitAgreement = async agreementType => {
        const agreement = hasSignAgreementMap[agreementType]

        if (!agreement) {
            $message.error('为了保证您的合作更顺畅，请先阅读并了解《在线支付使用须知》')
            return false
        }

        await fetchSignAgreement(agreementType)

        return true
    }

    return {
        getIsSign,
        fetchSignAgreement,
        hasSignAgreementMap,
        showAgreementMap,
        submitAgreement,
        updateHasSignAgreement
    }
}
